import { combineReducers } from "@reduxjs/toolkit";
import assetsReducer from "./assetsSlice";
import utilizationEventsReducer from "./utilizationEventsSlice";

export default combineReducers({
  assets: assetsReducer,
  utilizationEvents: utilizationEventsReducer,
});
